import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import GlobalAccountProfileModal from "components/shared/GlobalAccountProfileModal"
import TempSessionOverlay from "components/Consume/TempSessionOverlay"
import Footer from "./Footer"

import styles from "./Layout.module.scss"

const Layout = ({ children }) => {
  return (
    <div className="d-flex flex-column h-100">
      <TempSessionOverlay />
      <div className={classNames("flex-1", styles.body)}>{children}</div>
      <Footer />
      <GlobalAccountProfileModal />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node
}

export default Layout
